export const phasesConfig = {
    framesToWaitForSkipAfterPhaseStarts: 10
};
//# sourceMappingURL=index.js.map